import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function PageTemplate({ title, data }) {

    if (title === "College Development Committe") {
        return (
            <div className='container mt-4 '>
                <h2 className='text-center mb-4'>{title}</h2>
                <table className='table table-bordered table-striped'>
                    <thead className='thead-dark'>
                        <tr>
                            <th>Sr.No</th>
                            <th>Name</th>
                            <th>Post</th>
                            <th>Post Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.map((object, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{object.name}</td>
                                <td>{object.post}</td>
                                <td>{object.postname}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    } else {
        return (
            <div className='container mt-4 '>
                <h2 className='text-center mb-4'>{title}</h2>
                <table className='table table-bordered table-striped'>
                    <thead className='thead-dark'>
                        <tr>
                            <th>Sr.No</th>
                            <th>Name</th>
                            <th>Designation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.map((object, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{object.name}</td>
                                <td>{object.postname}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

}

export default PageTemplate;
